import React from "react";
import {  Col, Form, Row } from "react-bootstrap";
import CcAssessmentPathwayEnrollment, { CCAssessmentPathwayHelper } from "../Models/CcAssessmentPathwayEnrollment";
import { getDateWithOffset } from "../../Shared/Utility/GetDateWithOffset";


interface IProps{
    pathwayEnrollment: CcAssessmentPathwayEnrollment;
}

export default function AnnualFeePreview(props: IProps){
    const getEnrolledCertificates = () => {
        return props.pathwayEnrollment.ccEnrollmentCertificates.filter(_ => _.isEnrolled);
    }

    
    return(
        <React.Fragment>
        <div className="pp-assessment-review-section">
        <p className="font-weight-bold">Annual Fee</p>
        <Form.Group>
            <Col>
                <Row className="pp-assessment-review-item">
                        <Col><strong>Certification</strong></Col>
                    </Row>
                    {getEnrolledCertificates().map(_ => 
                    <Row key={_.certificateId} className="pp-assessment-review-item">
                        <Col className="pp-assessment-review-item-col">{_.certificationName} { _.isFuture && <span className="subscript">(Fee will be applied starting: {getDateWithOffset(_.enrollmentStartDate).toLocaleDateString('en-US')})</span>}</Col>
                    </Row>
                )}
                <Row className="pp-assessment-review-item">
                    <Col><strong>Total: ${CCAssessmentPathwayHelper.getAnnualFee(props.pathwayEnrollment)}</strong></Col>
                </Row>
            </Col>
            
        </Form.Group>
        
        </div>
    </React.Fragment>
    );
}